// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SecurityCorrelationsCategory from './SecurityCorrelationsCategory';


class SecurityCorrelationsQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCategory: null
    };
    this.makeHandleToggle = this.makeHandleToggle.bind(this);
  }

  makeHandleToggle(id) {
    return () => {
      if (this.isCategoryActive(id)) {
        this.setState({ activeCategory: null });
      } else {
        this.setState({ activeCategory: id });
      }
    };
  }

  isCategoryActive(id) {
    return this.state.activeCategory === id;
  }

  render() {
    const { categories, onAnswer } = this.props;

    return (
      <div className='security-correlation-questions'>
        {categories.map(category => (
          <SecurityCorrelationsCategory
            onToggle={this.makeHandleToggle(category.id)}
            onAnswer={onAnswer}
            active={this.isCategoryActive(category.id)}
            key={category.id}
            category={category}
          />
        ))}
      </div>
    );
  }
}

SecurityCorrelationsQuestions.propTypes = {
  categories: PropTypes.array.isRequired,
  onAnswer: PropTypes.func.isRequired
};

export default SecurityCorrelationsQuestions;



// WEBPACK FOOTER //
// ./src/components/correlations/SecurityCorrelationsQuestions.js